import { Avatar, Button, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { BrandEnum } from "../../../_common/enum/brand.enum";
import { IMortgageQuote } from "../../../_common/interface/mortgageQuote/iMortgageQuote.interface";
import { getBrandCallbackLink, getBrandLogoSymbol, getBrandSecondaryColor } from "../../../_helpers/brand.helper";
import { getMoneyFormat } from "../../../_helpers/format.helper";
import { isGreenMortgage } from "../../../_helpers/lowQuote.format.helper";
import { QuoteProviderLogoView } from "../../quotes/quoteProviderLogo-view";

export function MortgagesQuoteCardMobile(params: { item: IMortgageQuote, brand: BrandEnum, onApply: (id: number, quoteId: number) => void }) {
    const isBrandLogo =
        (params.brand === BrandEnum.LowQuote && params.item.isUsingLowQuoteLogo) ||
        (params.brand === BrandEnum.Low && params.item.isUsingLowLogo) ||
        (params.brand === BrandEnum.Hello && params.item.isUsingHelloLogo) ||
        (params.brand === BrandEnum.TrueWealth && params.item.isUsingTrueWealthLogo);

    const rateLabel = isGreenMortgage(params.item.mortgageName)
        ? "Green " + (params.item.fixedPeriod === 0 ? "Variable rate" : `${params.item.fixedPeriod / 12} years fixed`)
        : params.item.fixedPeriod === 0
            ? "Variable rate"
            : `${params.item.fixedPeriod / 12} years fixed`;

    return (
        <Grid item marginBottom={1}>
            <Card>
                <Grid container spacing={2} height="100%">
                    <Grid item xs={6}>
                        <Avatar
                            variant="square"
                            sx={{
                                bgcolor: "transparent",
                                padding: 0,
                                width: 104,
                                height: 104,
                            }}
                        >
                            {isBrandLogo ? (
                                <img
                                    src={getBrandLogoSymbol(params.brand)}
                                    alt="Logo"
                                    style={{ width: "100%", height: "100%", padding: 2 }}
                                />
                            ) : (
                                    <QuoteProviderLogoView providerId={params.item.providerId} />
                            )}
                        </Avatar>
                    </Grid>

                    <Grid item xs={6} container alignItems="center">
                        <Typography variant="h6">{rateLabel}</Typography>
                    </Grid>
                </Grid>

                <Divider />

                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={6} marginTop={1}>
                            <Typography variant="h6">{params.item.rate}%</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {params.item.fixedPeriod === 0 ? "Variable rate" : `${params.item.fixedPeriod / 12} years fixed rate`}
                            </Typography>
                        </Grid>

                        <Grid item xs={6} marginTop={1}>
                            <Typography variant="h6">{params.item.maxLoanToValue}%</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Max LTV
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="h6">{params.item.apr}%</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Indicative APRC*
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant="h6" fontWeight="bold">
                                {getMoneyFormat(params.item.monthlyPayment)}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Monthly Payment
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => window.open(getBrandCallbackLink(params.brand), "_blank", "noopener,noreferrer")}
                                sx={{ width: "90%", height: "50px" }}
                            >
                                <Typography variant="subtitle2">Schedule an appointment</Typography>
                            </Button>
                        </Grid>

                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                onClick={() => params.onApply(params.item.id, params.item.quoteId)}
                                sx={{ bgcolor: getBrandSecondaryColor(params.brand), paddingRight: "10px", width: "90%", height: "50px" }}
                                size="small"
                            >
                                <Typography variant="subtitle2">Apply now</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
}
